import { combineReducers } from "redux";
import CategoryRedutor from "./CategoryReducer";
import UserReducer from "./UserReducer";
import ProfessionalReducer from "./ProfessionalReducer";
import ConsultsReducer from "./ConsultsReducer";
import ChatReducer from "./ChatReducer";

const rootReducer = combineReducers({
  category: CategoryRedutor,
  user: UserReducer,
  professional: ProfessionalReducer,
  consults: ConsultsReducer,
  chats: ChatReducer
});

export default rootReducer;
